import type { RefObject } from 'react';

import { HelpCircleFillIcon, Text, Tooltip, type TypeTableColumn } from '@thefarmersfront/kitchen';

import type { TypeDeliveryAgencyOutboundUnit } from '~/types/delivery-agency.types';

import styles from './getDeliveryAgencyOutboundUnitColumnDefs.module.scss';

const CREATE_UNAVAILABLE_TOOLTIP = (
  <>
    {'해당 출고번호에 속한 모든 주문이\n'}
    <Text size="small" color="white" element="span" bold>
      주문취소 상태
    </Text>
    {'이거나 '}
    <Text size="small" color="white" element="span" bold>
      배송예정일이 과거
    </Text>
    {'인 경우\n추가 운송장 생성이 불가합니다.'}
  </>
);

const getDeliveryAgencyOutboundUnitColumnDefs = (tooltipPortalTargetRef: RefObject<HTMLElement | null>) => {
  const columnDefs: TypeTableColumn<TypeDeliveryAgencyOutboundUnit>[] = [
    {
      accessorKey: 'outboundCode',
      header: '출고번호',
      size: 160,
    },
    {
      accessorKey: 'isCreatableShippingLabel',
      header: '추가 운송장 생성 가능 여부',
      size: 200,
      cell: ({ row }) => {
        if (row.original.isCreatableShippingLabel) {
          return <span className={styles['creatable-text']}>생성 가능</span>;
        }

        return (
          <span className={styles['creatable-cell']}>
            <span className={styles['creatable-text']}>생성 불가능</span>
            <Tooltip
              description={CREATE_UNAVAILABLE_TOOLTIP}
              maxWidth="243px"
              portalTarget={tooltipPortalTargetRef.current}
            >
              <HelpCircleFillIcon size={16} color="#672091" />
            </Tooltip>
          </span>
        );
      },
    },
    {
      accessorKey: 'shippingLabelNumbers',
      header: '운송장 번호',
      size: 245,
      cell: ({ row }) => (
        <span className={styles['shipping-label-numbers']}>{row.original.shippingLabelNumbers?.join('\n') ?? '-'}</span>
      ),
      meta: { overflow: 'wrap', cellStyle: { paddingTop: 5, paddingBottom: 5 } },
    },
    {
      accessorKey: 'receiverName',
      header: '수령자명',
      size: 100,
    },
    {
      accessorKey: 'productName',
      header: '상품명',
      minSize: 252,
      meta: { flex: true },
    },
  ];

  return { columnDefs };
};

export default getDeliveryAgencyOutboundUnitColumnDefs;
